module.exports = __webpack_public_path__ + "media/images/stallion_description-62a6c9aab630b859970e5efc0ada028e.png";